import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

export const Card = styled.section`
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    padding: 16px 24px;
    display: flex;
    align-items: center;
    gap: 14px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        padding: 14px 16px;
        gap: 12px;
    }

    svg {
        flex: 0 0 auto;
        font-size: 20px;
        color: ${colors.success};
    }
`;

export const Text = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Title = styled.div`
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const Value = styled.div<{ $mono?: boolean }>`
    margin-top: 2px;
    font-size: 13px;
    color: ${colors.textSecondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${({ $mono }) => ($mono ? "ui-monospace, Menlo, monospace" : "inherit")};
`;

export const Note = styled.span`
    flex: 0 0 auto;
    font-size: 12px;
    color: ${colors.textSecondary};

    /* На узком вьюпорте место занимает значение шага, подпись о сохранении уходит. */
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const Action = styled.div`
    flex: 0 0 auto;
`;
